import { useCallback, useMemo } from "react";
import { useDashboardContext } from "../contexts/dashboard-context";
import { SpreadDesignId } from "../types/SpreadDesignId";
import { useReuseZonesForPages } from "./useReuseZonesForPages";
import { useSelectedSpread } from "./useSelection";
import { useAreSpreadDesignsSupported } from "./useSpreadDesigns";

export function useSpreadDesign() {
	const dashboard = useDashboardContext();
	const spread = useSelectedSpread();
	const [getAndSetReuseZones] = useReuseZonesForPages();

	const canChangeSpreadDesign = !!spread?.pageZones.every((page) =>
		dashboard.canReplacePage(page),
	);
	const areSpreadDesignsAvailableForSpread = useAreSpreadDesignsSupported();

	const currentSpreadDesginHash = useMemo(
		() => (spread ? SpreadDesignId.fromSpread(spread) : undefined),
		[spread],
	);

	const setSpreadDesign = useCallback(
		(spreadDesign: eXpress.creator.IConfigurationLayoutItem[]) => {
			if (!spread) return false;

			const zonesToReuseForSpread = getAndSetReuseZones(spread);

			// Apply spread design
			dashboard.applySpreadDesign(spreadDesign, spread, zonesToReuseForSpread);

			return true;
		},
		[dashboard, spread, getAndSetReuseZones],
	);

	return [
		currentSpreadDesginHash,
		canChangeSpreadDesign && areSpreadDesignsAvailableForSpread ? setSpreadDesign : undefined,
	] as const;
}
